import { SpinnerSize } from '@fluentui/react';
import { Spinner } from '@talxis/react-components';

export const LoadingOverlay = () => {
    return <Spinner size={SpinnerSize.large} />
}